export const TableStyles = {
  // Success message styles for applied view
  successSnackbar: {
    marginTop: "80px",
  },

  successAlert: {
    width: "100%",
    backgroundColor: "#4caf50",
    color: "#fff",
    fontWeight: 500,
    boxShadow: "0 4px 12px rgba(76, 175, 80, 0.4)",
    "& .MuiAlert-icon": {
      color: "#fff",
    },
  },

  // Snackbar positioning
  snackbarPosition: {
    vertical: "top" as const,
    horizontal: "center" as const,
  },
} as const;